// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Deal, VehicleType } from '@interfaces/deal.interfaces';
import { Lead } from '@interfaces/lead.interfaces';

@Component({
    selector: 'edit-vehicle-info-modal',
    templateUrl: './edit-vehicle-info-modal.component.html',
    styleUrls: ['./edit-vehicle-info-modal.component.scss'],
})
export class EditVehicleInfoModalComponent implements OnDestroy {
    private isComponentAlive = true;
    public vehicleInfo: any;
    public dealInfo: any;
    public title: string;
    public search = false;
    public type: 'jacket' | 'lead' = 'jacket';
    public vehicleType: VehicleType = VehicleType.Vehicle;
    protected readonly VehicleType = VehicleType;

    constructor(
        private dialogRef: MatDialogRef<EditVehicleInfoModalComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            deal?: Deal;
            lead?: Lead;
            type?: 'jacket' | 'lead';
            title: string;
            search?: boolean;
            vehicleType?: VehicleType;
        }
    ) {
        this.title = this.data.title;

        if (this.data.type) {
            this.type = this.data.type;
        }

        let vehicleTypeString: 'vehicle' | 'tradeInVehicle' = 'vehicle';

        if (this.data.vehicleType) {
            this.vehicleType = this.data.vehicleType;
            switch (this.vehicleType) {
                case VehicleType.TradeIn:
                    vehicleTypeString = 'tradeInVehicle';
                    break;
                case VehicleType.Vehicle:
                default:
                    vehicleTypeString = 'vehicle';
                    break;
            }
        }

        if (this.data.lead) {
            this.vehicleInfo = {
                bodyStyle: this.data.lead.bodyStyle,
                make: this.data.lead.make,
                model: this.data.lead.model,
                year: this.data.lead.year,
                stockNumber: this.data.lead.stockNumber,
                trim: this.data.lead.trim,
                vin: this.data.lead.vin,
                vehicleExt: {
                    priceInternet: this.data.lead.price,
                    status: this.data.lead.status,
                    image: this.data.lead.image,
                },
            };
        } else {
            this.vehicleInfo = this.data.deal[vehicleTypeString];
        }

        this.dealInfo = this.data.deal;

        if (this.data?.search) {
            this.search = this.data.search;
        }
    }

    public closeModal(vehicle: any) {
        if (vehicle && this.type === 'lead') {
            vehicle.image = vehicle?.vehicleExt?.image;
            vehicle.images = vehicle?.vehicleExt?.images;
        }

        this.dialogRef.close(vehicle);
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
